import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../utils/firebase';

const BlankScoreSheet = () => {
    const { leagueId, matchId, print, header} = useParams();
    const [matchDetails, setMatchDetails] = useState({});
    const [players, setPlayers] = useState([]);
    const [leagueSettings, setLeagueSettings] = useState({});
    const [flights, setFlights] = useState([]);
    const [leagueData, setLeagueData] = useState({});

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}/settings`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            console.log('League settings data:', data);
            if (data) {
                setLeagueSettings(data);
            } else {
                console.error('No settings found for the given leagueId.');
            }
        }, (error) => {
            console.error('Error fetching league settings from Firebase:', error);
        });
    }, [leagueId]);

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                console.log('League data:', data);
                setLeagueData(data);
                setLeagueSettings(data.settings || {});
                const matchData = data.matches[matchId];
                console.log('Match data:', matchData);
                if (matchData) {
                    setMatchDetails(matchData);
                    const matchDate = matchData.dateTime * 1000;
                    const relevantHandicapSet = Object.values(data.handicaps || {}).find(handicapSet => {
                        return handicapSet.startDate * 1000 <= matchDate && matchDate <= handicapSet.endDate * 1000;
                    });
                    console.log('Relevant handicap set:', relevantHandicapSet);
                    setFlights(Object.values(relevantHandicapSet?.flights || {}));
                    const activePlayers = Object.keys(data.players || {}).map(playerId => ({
                        ...data.players[playerId],
                        handicap: relevantHandicapSet?.playerHandicaps[playerId] || 0
                    }));
                    setPlayers(activePlayers);
                } else {
                    console.log('No match data found for the given matchId.');
                }
            } else {
                console.log('No league data found for the given leagueId.');
            }
            if (print === 'true') {
                setTimeout(() => {
                    window.print();
                }, 100); // 2 seconds delay
            }
        }, (error) => {
            console.error('Error fetching league data from Firebase:', error);
        });
    }, [leagueId, matchId]);

    const formatDate = (timestamp) => {
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return new Date(timestamp * 1000).toLocaleDateString(leagueSettings.language, options);
    };

    const formatTime = (timestamp) => {
        const options = { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: leagueSettings.timeZone };
        return new Date(timestamp * 1000).toLocaleTimeString(leagueSettings.language, options);
    };

    return (
        <div style={{backgroundColor: '#ffffff'}}>
            <div className={'modern-report report-container'}>
                <div className="modern-report-container">
                    {header === 'true' && (
                        <div className={'modern-report-header'}>
                            <h1>Score Sheet</h1>
                            <h3>{leagueData.name}</h3>
                            <h4>{leagueData.parentGroup}</h4>
                            <h4>{matchDetails.name}</h4>
                            <h4>{matchDetails.dateTime ? `${formatDate(matchDetails.dateTime)} - ${formatTime(matchDetails.dateTime)}` : ''}</h4>
                        </div>
                    )}
                    <div className="tables-container">
                        {flights.map((flight, flightIndex) => (
                            <div key={flightIndex} className="flight-table">
                                <h3 style={{marginLeft: "15px"}}>{flight.name}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th width="50%">Player Name</th>
                                            <th width="28%">Handicap</th>
                                            <th width="22%">Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {players
                                            .filter(player =>
                                                player.handicap >= Number(flight.start) &&
                                                player.handicap <= Number(flight.end)
                                            )
                                            .map((player, index) => (
                                                <tr key={index}>
                                                    <td>{player.name}</td>
                                                    <td>{player.handicap}</td>
                                                    <td>
                                                        <input
                                                            style={{
                                                                height: '15px',
                                                                width: '80%',
                                                                border: 'lightgray solid 1px',
                                                                fontSize: '20px'
                                                            }}
                                                            type="text"
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlankScoreSheet;